<h2 mat-dialog-title>
  {{ "Masters.clinics.DeleteRoom" | translate}}
</h2>
<mat-divider></mat-divider>
<mat-dialog-content fxLayout="column">
  <div class="chip-list-container">
    <mat-chip-list #chipGrid class="chip-list" multiple>
      <mat-chip [selected]="room.is_selected" (keyup.space)="room.is_selected = !room.is_selected"
        (click)="room.is_selected = !room.is_selected" *ngFor="let room of roomArray; index as i" [value]="room.id">
        <mat-checkbox [checked]="room.is_selected" (click)="$event.preventDefault()">{{room.name}}</mat-checkbox>
      </mat-chip>
    </mat-chip-list>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" fxLayoutGap="20px">
  <button class="mat-raised-button mat-secondary" (click)="close()">
    {{ "Close" | translate }}
  </button>
  <button class="mat-raised-button mat-primary" (click)="deleteRoom()">
    {{ "Delete" | translate }}
  </button>
</mat-dialog-actions>